import { render, staticRenderFns } from "./WidgetBase.vue?vue&type=template&id=5a809602&scoped=true&"
import script from "./WidgetBase.vue?vue&type=script&lang=js&"
export * from "./WidgetBase.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBase.vue?vue&type=style&index=0&id=5a809602&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a809602",
  null
  
)

export default component.exports